import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom'
import { dateTimeToView } from '../../../../utils/date.utils';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { ELibraryApi, library_list } from '../../../../api/e-library/e_library.api';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { checkPermission, renderDate } from '../../../../utils/app.utils';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { routeName } from '../../../../routes/routeName';
import { library_type_list, LibraryTypeApi } from '../../../../api/library-type/library_type.api';
import moment from 'moment';
import { header_detail } from '../../enum/elibrary_enum';
import SwitchCustom from '../../../../components/switch/SwitchCustom';
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom';
import { RootState } from '../../../../store/store';

type Props = {
    category: ELibraryCategory;
    code?: string;
}
export const useManageState = ({ category, code = 'e_library_search_global' }: Props) => {
    // CONSTANCE
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const path_name = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'))
    const header_data = header_detail(t)?.find((x) => x.key === category);

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission(code, permission);


    // HOOKS
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);
    const [id_library_type, set_id_library_type] = useState<any>(null);
    const [library_type, set_library_type] = useState<any[]>([]);
    const [search_library_type, set_search_library_type] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_by");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);

    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: header_data?.header_name || ""
        },
        {
            id: "AA", disablePadding: false, align: "center", width: 140, label: t("หมวดหมู่")
        },
        ...([ELibraryCategory.BOOK, ELibraryCategory.E_BOOK].includes(category) ? [
            {
                id: "1", disablePadding: false, align: "center", width: 141, label: t("จำหน่าย")
            },
        ] : []),
        ...([ELibraryCategory.BOOK, ELibraryCategory.E_BOOK].includes(category) ? [
            {
                id: "2", disablePadding: false, align: "center", width: 141, label: t("ให้ยืม")
            },
        ] : []),
        ...([ELibraryCategory.BOOK].includes(category) ? [
            {
                id: "333", disablePadding: false, align: "center", width: 141, label: t("จำนวนให้ยืมคงเหลือ")
            },
        ] : []),
        ...([ELibraryCategory.E_BOOK].includes(category) ? [
            {
                id: "2.1", disablePadding: false, align: "center", width: 100, label: t("คงเหลือให้ยืม")
            },
            {
                id: "2.2", disablePadding: false, align: "center", width: 100, label: t("จำนวนให้ยืม")
            },
        ] : []),
        ...([ELibraryCategory.BOOK].includes(category) ? [
            {
                id: "3", disablePadding: false, align: "center", width: 141, label: t("จำนวนจำหน่ายคงเหลือ")
            },
        ] : []),
        {
            id: "4.1", disablePadding: false, align: "center", width: 141, label: t("สถานะการเผยแพร่")
        },
        {
            id: "4", disablePadding: false, align: "center", width: 141, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "5", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            library_head_name,
            remaining_sales_qty,
            created_by,
            modified_date,
            library_type_names,
            id_library_head,
            is_sales,
            is_rent,
            status,
            modified_by,
            rent_qty,
            remaining_rent_qty,
            sales_qty
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: library_head_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: library_type_names || "-",
                },
                ...([ELibraryCategory.BOOK, ELibraryCategory.E_BOOK].includes(category) ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label: <div className="flex ml-4 justify-center items-center"><CheckBoxCustom checked={!!is_sales} /></div>

                    },
                ] : []),
                ...([ELibraryCategory.BOOK, ELibraryCategory.E_BOOK].includes(category) ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label: <div className="flex ml-4 justify-center items-center">
                            <CheckBoxCustom checked={!!is_rent} />
                        </div>
                    },
                ] : []),
                ...([ELibraryCategory.BOOK].includes(category) ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label:`${remaining_rent_qty ?? "0"}/${rent_qty ?? "0"}`
                    },
                ] : []),
                ...([ELibraryCategory.E_BOOK].includes(category) ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label: (remaining_rent_qty || "-")
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: rent_qty || "-"
                    },
                ] : []),
                ...([ELibraryCategory.BOOK].includes(category) ? [
                    {
                        option: "TEXT",
                        align: "center",
                        label: (remaining_sales_qty || "-") + "/" + (sales_qty || "-")
                    },
                ] : []),
                {
                    option: "TEXT",
                    align: "center",
                    label: <div className='w-full flex justify-center items-center'>
                        <SwitchCustom
                            checked={status === 'active'}
                            onChange={(st) => handleUpdateStatus(id_library_head, st)}
                        />
                    </div>
                },
                {
                    option: "TEXT",
                    align: "center",
                label: modified_by || created_by || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? renderDate(modified_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => {
                                if (id_library_head) {
                                    if (category === ELibraryCategory.BOOK) {
                                        navigate(routeName.e_library.manage_books_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.E_BOOK) {
                                        navigate(routeName.e_library.manage_e_books_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.THESIS) {
                                        navigate(routeName.e_library.manage_the_ses_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.MAGAZINE) {
                                        navigate(routeName.e_library.manage_journal_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.PODCAST) {
                                        navigate(routeName.e_library.manage_podcast_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.VIDEO) {
                                        navigate(routeName.e_library.manage_videos_view.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.AUDIO_BOOK) {
                                        navigate(routeName.e_library.manage_audio_book_view.replace(":id", id_library_head))
                                    }
                                }
                            }}
                            onEditClick={() => {
                                if (id_library_head) {
                                    if (category === ELibraryCategory.BOOK) {
                                        navigate(routeName.e_library.manage_books_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.E_BOOK) {
                                        navigate(routeName.e_library.manage_e_books_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.THESIS) {
                                        navigate(routeName.e_library.manage_the_ses_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.MAGAZINE) {
                                        navigate(routeName.e_library.manage_journal_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.PODCAST) {
                                        navigate(routeName.e_library.manage_podcast_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.VIDEO) {
                                        navigate(routeName.e_library.manage_videos_detail.replace(":id", id_library_head))
                                    } else if (category === ELibraryCategory.AUDIO_BOOK) {
                                        navigate(routeName.e_library.manage_audio_book_detail.replace(":id", id_library_head))
                                    }

                                }
                            }}
                            onDeleteClick={() => handleDeleteList(id_library_head)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleUpdateStatus = async (id_library_head: number, status: boolean) => {
        dispatch(setLoading());
        await ELibraryApi.updateStatus(id_library_head, { status: status ? 'active' : 'inactive' }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleDeleteList = (id_library_head: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ELibraryApi.delete(id_library_head).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อยแล้ว"));
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ เรียบร้อยแล้ว"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetLibraryType = useCallback(async () => {
        let query: library_type_list = {
            page: 1,
            limit: 30,
        }
        if (search_library_type) query.search = search_library_type
        await LibraryTypeApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_library_type(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_library_type])

    const handleGetData = useCallback(async () => {
        let query: library_list = {
            page: page,
            limit: pageLimit,
            library_category_name: category
        }
        if (search) query.search = search;
        if (id_library_type) query.id_library_type = id_library_type?.id_library_type;
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");
        dispatch(setLoading());
        await ELibraryApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_data(response);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        }
        )
    }, [page, pageLimit, search, id_library_type, start_date, end_date])

    useEffect(() => {
        handleGetLibraryType();
    }, [handleGetLibraryType])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        path_name,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        set_search_library_type,
        set_id_library_type,
        id_library_type,
        library_type,
        header_detail,
        checkPermit
    }
}

